/** @format */
import imgMA from "../assets/rawimage/m_a.png";
import imgTrading from "../assets/retail.png";
import imgInterior from "../assets/rawimage/interior.png";

export const DataActivities = [
  {
    key: 1,
    img: imgMA,
    title: "M&A",
    desc: "Hoang Thanh Group has a solid track record and strong market reputation with decades of combined investment banking experience in Vietnam. Drawing from our deep experiences working with Governmental institutions, multinational corporations, global financial institutions and top Vietnamese corporations, we aim to provide a unique investment banking services experience to clients that share our core values.",
  },
];

export const DataActivities_2 = [
  {
    key: 1,
    img: imgTrading,
    title: "Retail Trading",
    desc: "Through our portfolio company, Hoang Thanh Group is active in retail trading offering services such as end-to-end B2B or B2C distribution, delivering products to Vietnamese consumers through a value chain of planning, organizing, marketing, warehousing and delivery.",
  },
  {
    key: 2,
    img: imgInterior,
    title: "Real Estate & Hospitality",
    desc: "Hoang Thanh Group owns, design, and operates a number of mixed-used luxury office buildings and hotels and Hanoi and HCMC.Hoang Thanh Group also own an architect and interior design subsidiary with its philosophy centered around eat clean, breath clean, brain clean, work clean, and live clean. ",
  },
];

export const dataCompanyCulture = [
  {
    key: 1,
    title: "Accountability:",
    desc: [
      {
        key: 1,
        content:
          "Create an environment where open dialogue is encouraged where regular feedback, transparent discussions and active listening help reinforce accountability.",
      },
      {
        key: 2,
        content:
          "Promotes a culture of accountability where employees take ownership of their work, deliver results with excellence and hold themselves and others to high standards of pertormance.",
      },
      {
        key: 3,
        content:
          "Encourages proactive problem-solving, initiative and a sense of personal responsibility for the company's success.",
      },
    ],
  },

  {
    key: 2,
    title: "Adaptability:",
    desc: [
      {
        key: 1,
        content:
          "Encourages flexibility, resilience and a willingness to embrace change as opportunities for growth and innovation.",
      },
      {
        key: 2,
        content:
          "Encourages flexibility, resilience and a willingness to embrace change as opportunities for growth and innovation rather than disruption.",
      },
      {
        key: 3,
        content:
          "We believe the best solutions come from diverse perspectives. We encourage experimentation, brainstorming and embracing new ways of thinking.",
      },
    ],
  },
  {
    key: 3,
    title: "Collaboration:",
    desc: [
      {
        key: 1,
        content:
          "Fosters a collaborative work environment where teamvvork, communication and mutual respect are valued.",
      },
      {
        key: 2,
        content:
          "Together we're stronger - we achieve more through collaboration.",
      },
      {
        key: 3,
        content:
          "Great ideas spark from teamwork - we collaborate to innovate.",
      },
      {
        key: 4,
        content:
          "We value individual expertise, but success comes through collaboration.",
      },
      {
        key: 5,
        content:
          "Shared goals unite us - we collaborate to achieve the best possible outcome.",
      },
    ],
  },

  {
    key: 4,
    title: "Compassion:",
    desc: [
      {
        key: 1,
        content:
          "Foster a compassionate environment to create a workplace where everyone feels valued, understood and uplifted.",
      },
      {
        key: 2,
        content:
          "Genuinely care for one another, recognizing that each person faces unique challenges.",
      },
      {
        key: 3,
        content:
          "Actively listen, empathize and support our colleagues during both professional and personal moments.",
      },
    ],
  },

  {
    key: 5,
    title: "Diligence:",
    desc: [
      {
        key: 1,
        content:
          "Foster a culture of careful consideration and thoroughness, we set high standards and embrace meticulous attention to detail.",
      },
      {
        key: 2,
        content:
          "Diligence is our compass, guiding us toward quality and excellence. We leave no stone unturned in our pursuit of perfection.",
      },
      {
        key: 3,
        content:
          "Our commitment to diligence ensures consistent, reliable and excellence outcomes.",
      },
    ],
  },
  {
    key: 6,
    title: "Fun:",
    desc: [
      {
        key: 1,
        content:
          "Foster a positive and engaging work environment by incorporating elements of fun, camaraderie and celebration into the workplace.",
      },
      {
        key: 2,
        content:
          "Encourages and organizes team-building activities, social events and recognition programs to celebrate achievements, milestones and successes together.",
      },
      {
        key: 3,
        content: "Everyone shall live an excellent life.",
      },
    ],
  },
  {
    key: 7,
    title: "Innovation:",
    desc: [
      {
        key: 1,
        content:
          "Encourages a culture of innovation where employees are empowered to think creatively, challenge the status quo, and propose new ideas to improve products, processes, and services.",
      },
      {
        key: 2,
        content:
          "Values entrepreneurial spirit, risk-taking and experimentation to drive continuous improvement and stay ahead in the competitive environment.",
      },
      {
        key: 3,
        content:
          "Foster an environment where creativity thrives, risks are taken and breakthroughs happen.",
      },
    ],
  },
  {
    key: 8,
    title: "Self-Development:",
    desc: [
      {
        key: 1,
        content:
          "Encourage self learning and development initiatives to toster continuous growth, skill-building and career advancement opportunities.",
      },
      {
        key: 2,
        content:
          "Provides access to training programs, mentorship and resources to help employees develop new skills, expand their knowledge, and achieve their proffessional goals.",
      },
      {
        key: 3,
        content:
          "Foster a strong self learning and development culture not only enhances individual capabilities but also contributes to the overall success of the organization.",
      },
    ],
  },
  {
    key: 9,
    title: "Transparency:",
    desc: [
      {
        key: 1,
        content:
          "Encourages open and honest communication at all levels of the organization, enabling employees to voice their opinions, concerns and ideas without fear of reprisal.",
      },
      {
        key: 2,
        content:
          "We celebrate open communication and information sharing, fostering a culture of trust.",
      },
      {
        key: 3,
        content:
          "We embrace honest feedback, both positive and negative, to continuously improve through transparency.",
      },
    ],
  },
  {
    key: 10,
    title: "Well-being:",
    desc: [
      {
        key: 1,
        content:
          "Foster a culture that prioritizes eat clean, drink clean, breath clean, brain clean, work clean as a guiding compass to maintaining a healthy and sustainable liíestyle.",
      },
      {
        key: 2,
        content: "Everyone should live an excellent life.",
      },
      {
        key: 3,
        content:
          "Encourage flexible work arrangements, wellness programs and initiatives to promote physical, mental and emotional health among employees.",
      },
    ],
  },
  {
    key: 11,
    title: "Willpower:",
    desc: [
      {
        key: 1,
        content:
          "Foster a culture that embrace challenges with unwavering willpower, achieving the seemingly impossible.",
      },
      {
        key: 2,
        content:
          "We believe that self-driven individuals not only achieve personal success but also elevate the entire organization.",
      },
      {
        key: 3,
        content:
          "Difficulties do not deter us - they ignite our willpower to succeed. We believe will power can transform ideas into reality.",
      },
    ],
  },
  {
    key: 12,
    title: "Wisdom:",
    desc: [
      {
        key: 1,
        content:
          "Prioritize well-considered choices based on experience, knowledge and a clear understanding of potential consequences.",
      },
      {
        key: 2,
        content:
          "Encourage employees to actively learn from successes and failures, both our own and those of others and develop the ability to assess situations accurately and make insightful decisions.",
      },
      {
        key: 3,
        content:
          "Encourage balanced perspective considering all sides of an issue and approaching challenges with a long-term view to make informed choices.",
      },
    ],
  },
];
